export default __webpack_public_path__ + "static/media/roadmap_mobail_line.adc3de19.png";